import { useState } from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../styles/whatsapp-button.css";
import "../../styles/wa-message-box.css";

import { MessagePromptBox } from "./message-prompt-box";

export const WhatsappButton = () => {
  

    const [openMessageBox, setOpenMessageBox] = useState(false);

    return (
        <div className="wh-button-container">
            {openMessageBox && (
                <MessagePromptBox
                    closeMessageBox={() => {
                        setOpenMessageBox(false);
                    }}
                />
            )}
            <button
                className="wh-button flx-rw c-al c-jt"
                onClick={() => setOpenMessageBox(true)}
            >
                <FontAwesomeIcon icon={faWhatsapp} />
            </button>
        </div>
    )
}